/**
 * Environment feature flag keys returned by GET /api/features and referenced on ServiceConfig.
 */
export const FeatureFlagKeys = {
  FlowerCatalog: 'FlowerCatalog',
  MailedCardCatalog: 'MailedCardCatalog',
  GiftCatalog: 'GiftCatalog',
} as const;

export type FeatureFlagKey = (typeof FeatureFlagKeys)[keyof typeof FeatureFlagKeys];
